import _ from 'underscore'

export default {

  obj: {
    isEmpty (obj) {
      return obj === undefined || obj == null || Object.keys(obj).length === 0
    },
    /**
     * 使用source的属性名去target找，并将target的值放到source中。
     * @param source
     * @param target
     * @param [ignoreProps] {Array} 忽略的属性名
     * @return source
     */
    getProperties (source, target, ignoreProps) {
      for (let key of Object.keys(source)) {
        if (ignoreProps !== undefined && ignoreProps.includes(key)) {
          continue
        }
        source[key] = target[key]
      }
      return source
    },
    /**
     * 将对象合并（不做深层复制）。
     * let obj = merge({}, obj1, obj2, ...)
     */
    merge () {
      let obj = arguments[0] || {}
      for (let i = 1; i < arguments.length; i++) {
        obj = Object.assign(obj, arguments[i])
      }
      return obj
    },
    isPlainObject (obj) {
      if (obj === null || typeof obj !== 'object') {
        return false
      }
      return Object.isPrototypeOf(obj) === Object.prototype
    },
    getObjectValue (obj, name) {
      if (obj) {
        let tmp = obj
        for (const key of name.split('.')) {
          tmp = tmp[key]
        }
        return tmp
      } else {
        return null
      }
    }
  },

  date: {
    format (date) {
      var d = date.getDate()
      var m = date.getMonth() + 1
      var y = date.getFullYear()
      return '' + y + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d)
    },
    nextMonth (now) {
      if (now === undefined || now === null) {
        now = new Date()
      }
      let curr
      if (now.getMonth() === 11) {
        curr = new Date(now.getFullYear() + 1, 0, 1)
      } else {
        curr = new Date(now.getFullYear(), now.getMonth() + 1, 1)
      }
      return curr
    },
    prevMonth (now) {
      if (now === undefined || now === null) {
        now = new Date()
      }
      let curr
      if (now.getMonth() === 0) {
        curr = new Date(now.getFullYear() - 1, 11, 1)
      } else {
        curr = new Date(now.getFullYear(), now.getMonth() - 1, 1)
      }
      return curr
    },
    toLastDayInMonth (date) {
      return new Date(date.getFullYear(), date.getMonth() + 1, 0)
    }
  },

  func: {
    /**
     * 安全的执行函数，如果函数不是有效的，则无任何效果。
     * @param func {Function}
     * @param [context] {Object | Array] 如果是一个数组，表示params参数，如果是对象，表示函数的上下文。
     * @param [params] {Array} func的参数。
     * @param [catchError] {boolean}
     */
    call (func, context, params, catchError) {
      if (!_.isFunction(func)) return
      if (_.isArray(context)) {
        params = context
        context = null
      }
      if (catchError === true) {
        try {
          return func.apply(context, params)
        } catch (e) {
          console && console.error(e)
        }
      } else {
        return func.apply(context, params)
      }
    }
  },

  arr: {
    /**
     * 使用obj从数组中查找，如果存在则替换，否则将obj添加到数组。
     * @param arr {Array}
     * @param obj {Object}
     * @param [idName] {String} 默认'id'，用来从arr中查找和obj的id相同的对象。
     * @return Array 返回arr，如果arr不是一个有效的数组则创建一个新数组，处理完成后返回该数组。
     */
    pushOrReplace (arr, obj, idName) {
      arr = arr || []
      idName = idName || 'id'
      let old = arr.find(o => o[idName] === obj[idName])
      if (old) {
        Object.assign(old, obj)
      } else {
        arr.push(obj)
      }
      return arr
    },
    /**
     * 使用obj从数组中查找，如果存在则替换，否则将obj插入到数组指定位置。
     * @see pushOrReplace
     * @param arr {Array}
     * @param index {int}
     * @param obj {Object}
     * @param [idName] {String} 默认'id'，用来从arr中查找和obj的id相同的对象。
     * @return {*|Array}
     */
    insertOrReplace (arr, index, obj, idName) {
      arr = arr || []
      idName = idName || 'id'
      let old = arr.find(o => o[idName] === obj[idName])
      if (old) {
        Object.assign(old, obj)
      } else {
        this.insert(arr, index, obj)
      }
      return arr
    },
    /**
     * 根据对象的id从数组中查找位置并删除。
     * @param arr {Array}
     * @param obj {Object} 需要从数组中删除的对象。
     * @param [idName] {string} 默认为'id'。
     * @return arr
     */
    remove (arr, obj, idName) {
      if (arr == null || arr === undefined || arr.length === 0) return []
      idName = idName || 'id'
      let index = arr.findIndex(o => o[idName] === obj[idName])
      index >= 0 && arr.splice(index, 1)
      return arr
    },
    /**
     * 从数组中移除项目。
     * @param arr
     * @param item
     * @return arr
     */
    removeItem (arr, item) {
      if (arr == null || arr === undefined || arr.length === 0) return []
      let index = arr.findIndex(o => o === item)
      index >= 0 && arr.splice(index, 1)
      return arr
    },
    /**
     * 插入元素到数组的指定位置。
     * @param arr
     * @param index
     * @param item {Object | Array}
     * @return {Array}
     */
    insert (arr, index, item) {
      if (!Array.isArray(arr)) {
        arr = []
      }
      if (index >= arr.length) {
        index = arr.length - 1
      }
      if (Array.isArray(item)) {
        arr.splice(index, 0, ...item)
      } else {
        arr.splice(index, 0, item)
      }
      return arr
    },
    /**
     * 求两个数组的交集。
     * @param arr1
     * @param arr2
     */
    intersect (arr1, arr2) {
      if (arr1 && arr1.length > 0 && arr2 && arr2.length > 0) {
        return arr1.filter(v => arr2.indexOf(v) !== -1)
      } else {
        return []
      }
    },
    find (arr, condition) {
      if (arr == null || arr === undefined || arr.length === 0) return null
      let idx = arr.findIndex(condition)
      if (idx > -1) {
        return arr[idx]
      } else {
        return null
      }
    }
  },

  str: {
    isBlank: (text) => text == null || text === undefined || text.trim().length === 0,
    /**
     * @param str
     * @param search 被替换的字符串，属于正则表达式
     * @param replaceStr 替换后的字符串
     */
    replaceAll: function (str, search, replaceStr) {
      return str.replace(new RegExp(search, 'g'), replaceStr)
    },
    repeat: function (char, times) {
      let c = ''
      for (let i = 0; i < times; i++) {
        c += char
      }
      return c
    },
    /**
     * 将字节数转换成人类易读的字符串。
     * @param size {int} 字节。
     * @param [decimal] {int} 小数位数，默认1，0表示没有小数。
     * @returns {string}
     */
    fmtSize: function (size, decimal) {
      if (decimal === undefined) {
        decimal = 1
      }
      if (size < 1024) {
        return size['toFixed'](decimal) + ' B'
      }
      size = size / 1024
      if (size < 1024) {
        return size['toFixed'](decimal) + ' KB'
      }
      size = size / 1024
      if (size < 1024) {
        return size['toFixed'](decimal) + ' MB'
      }
      size = size / 1024
      if (size < 1024) {
        return size['toFixed'](decimal) + ' GB'
      }
      size = (size / 1024)
      if (size < 1024) {
        return size['toFixed'](decimal) + ' TB'
      }
      return size + ''
    },
    /**
     * 将一个毫秒时间格式化为"xx时间前"的格式，如：4秒前，5分钟前，3小时前。
     * @param ms
     * @return {String | int} 如果返回0，表示此时间已经过了很久，不适合格式化这种格式了，你应该显示原本的日期时间。
     */
    fmtBeforeTime (ms) {
      let sec = parseInt((Date.now() - ms) / 1000)
      if (sec < 60) {
        return sec + '秒前'
      }
      if (sec <= 1500) { // 25分钟
        return parseInt(sec / 60) + '分钟前'
      }
      if (sec <= 1800) { // 半小时
        return '半小时前'
      }
      if (sec < 3600) { // 一小时前
        return parseInt(sec / 60) + '分钟前'
      }
      if (sec < 3600 * 24) {
        return parseInt(sec / 3600) + '小时前'
      }
      return 0
    },
    /**
     * 格式化数字为货币形式。
     * @param number 数值
     * @param [places] 保留多少位小数，默认2位
     * @param [symbol] 货币符号，默认人民币
     * @param [thousand] 整数区域的分隔符，默认","
     * @param [decimal] 小数点符号，默认"."
     * @returns {string}
     */
    fmtCurrency: function formatMoney (number, places, symbol, thousand, decimal) {
      number = number || 0
      places = !isNaN(places = Math.abs(places)) ? places : 2
      symbol = symbol || ''
      thousand = thousand || ', '
      decimal = decimal || '.'
      let negative = number < 0 ? '-' : ''
      let i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + ''
      let j = i.length > 3 ? i.length % 3 : 0
      let r = (symbol ? symbol + ' ' : '') + negative + (j ? i.substr(0, j) + thousand : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : '')
      let tmp = '.' + this.repeat('0', places)
      return r.replace(tmp, '')
    },
    split (str, sign) {
      if (str && str.length > 0) {
        return str.split(sign || ',')
      } else {
        return []
      }
    },
    ellipse (str, maxLength, suffix) {
      if (this.isBlank(str)) return ''
      if (str.length > maxLength) {
        return str.substring(0, maxLength) + (suffix || '...')
      } else {
        return str
      }
    },
    /**
     * 产生一个随机id
     * @param [len] id的长度，默认16位
     * @return {string}
     */
    id (len) {
      len = len || 16
      let chars = '123456789abcdefghijklmnopqrstuvwxyz'.split('')
      let uuid = []
      let radix = 16
      if (len) {
        for (let i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
      } else {
        let r
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
        uuid[14] = '4'
        for (let i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | Math.random() * 16
            uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
          }
        }
      }

      return uuid.join('')
    },
    /**
     * 获取文件名的后缀名（不包含"."符号）。
     * @param name
     * @return {String}
     */
    fileExt (name) {
      if (this.isBlank(name)) return ''
      let idx = name.lastIndexOf('.')
      if (idx === name.length - 1) return ''
      return name.substr(idx + 1, name.length)
    }
  },
  num: {
    /**
     * 将数字toFixed小数，并去除末尾的0，如：
     * 123.00 > 123
     * 123.01 > 123.01
     * 123.10 > 123.1
     * @param n 数字
     * @param point 小数位数
     * @return {number}
     */
    toFixedTrimZero (n, point) {
      let tmp = n.toFixed(point)
      tmp = tmp.replace(/0+$/, '')
      return parseFloat(tmp)
    }
  }
}
